module.exports = __webpack_public_path__ + "static/img/dy.113b07a.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/dy.png
// module id = Y+cP
// module chunks = 1